<div
  class="timer"
  title="The current position of the timeline"
  i18n-title
>
  {{milliseconds | milliseconds}}
</div>



// WEBPACK FOOTER //
// ./src/app/rec/components/timer/timer.component.html